export default __webpack_public_path__ + "assets/images/mock-ad-image-storage_2U0W9.jpg";